import helpers from "view-ui-admin/src/utils/helpers";
import consts from "@/utils/consts";

export default {
  ...helpers,
  getImageUrl({ id, width, height }) {
    let sizeParams = "";

    if (width && height) {
      sizeParams = `?imageMogr2/crop/${width}x${height}/gravity/center/interlace/0/quality/100`;
    }

    return `${consts.CdnUrl}/${id}${sizeParams}`;
  },
  addStyle(color) {
    const style = document.createElement("style");
    const innerText =
      `.c21 { color: ${color}; }` +
      `.bgc21 { background-color: ${color}; }` +
      `.b-swiper:before { background-color: ${color}!important; }` +
      `.c-title__title:before { background-color: ${color}; }`;

    style.type = "text/css";
    style.innerText = innerText;

    document.getElementsByTagName("head")[0].appendChild(style);
  }
};
